import axios from 'axios';

const SubscriptionApi = {};

const nonce = devsAccountingApi.nonce;  
SubscriptionApi.save = async (data) => {
    const url = "/wp-json/devs-accounting/v1/add-subscription/";
    try {
        const response = await axios.post(url, data, {
            headers: {
                'X-WP-Nonce': nonce,
                'Content-Type': 'application/json',
            },
        });
        if (response.status === 200) {
            return response.data;
        } else {
            return { error: 'Failed to create subscription, unexpected response.' };
        }
    } catch (error) {
        return error.response?.data || { error: 'Failed to save subscription' };
    }
};

SubscriptionApi.get = async (userId) => {
    const url = "/wp-json/devs-accounting/v1/get-subscription";
    try {
        const response = await axios.post(url, { user_id: userId }, {
            headers: {
                'X-WP-Nonce': nonce,
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            return response.data.subscriptions || [];
        } else {
            return { error: 'Failed to fetch subscriptions, unexpected response.' };
        }
    } catch (error) {
        return error.response?.data || { error: 'Failed to fetch subscriptions' };
    }
};


SubscriptionApi.activate = async (licenseKey) => {
    const url = "/wp-json/devs-accounting/v1/activate-license";
    try {
        const response = await axios.post(url, { license_key: licenseKey }, {
            headers: {
                'X-WP-Nonce': nonce,
                'Content-Type': 'application/json',
            },
        });

        return response.status === 200 ? response.data : { error: 'License activation failed' };
    } catch (error) {
        return error.response?.data || { error: 'License activation request failed' };
    }
};


export default SubscriptionApi;
